function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ced6e0;fill-rule:evenodd;}.b{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1174 -44)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M42,17.5A16.5,16.5,0,1,1,58.5,34,16.5,16.5,0,0,1,42,17.5Z",
  transform: "translate(1132 43)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(781.3 -5301.25)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M53.907,11.191a2.11,2.11,0,1,0-2.14,1.942h.024A1.95,1.95,0,0,0,53.907,11.191Z",
  transform: "translate(351 5344)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M53.661,14.666H49.921V25.9h3.739Z",
  transform: "translate(351 5344)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M62.84,14.4c2.461,0,4.305,1.606,4.305,5.057V25.9H63.407V19.89c0-1.51-.541-2.54-1.895-2.54a2.046,2.046,0,0,0-1.919,1.365,2.554,2.554,0,0,0-.123.911V25.9H55.73s.049-10.181,0-11.235h3.74v1.591A3.713,3.713,0,0,1,62.84,14.4Z",
  transform: "translate(351 5344)"
})));

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.2d221b29.svg";
export { ForwardRef as ReactComponent };